import React, { useEffect } from 'react';
import RatesAuditSearchView from './RatesAuditSearchView.jsx';
import RatesAuditTableView from './RatesAuditTableView.jsx';
import Moment from 'moment';
import { useLoadRecords } from './RatesAuditPageViewHooks';
import { useLocation, useSearchParams } from 'react-router-dom-v5-compat';
import { useDispatch, useSelector } from 'react-redux';
import { downloadAuditFile, downloadFile } from '../../RateAuditPageViewSlice';
import NotificationActions from '../../../../Common/Actions/NotificationActions';
import { selectAuditRecords, clearAuditRecords } from '../../RateAuditPageViewSlice';
import { parseFilterFromQueryString } from '../Business/RatesAuditHelpers';

const urlDateFormat = 'YYYY-MM-DDZZ';

export default function RatesAuditPageView()  {
    const dispatch = useDispatch();
    const location = useLocation();
    const auditRecords = useSelector(selectAuditRecords);
    useLoadRecords(location, urlDateFormat);

    function formatDate(date) {
        return date == undefined ? "" : Moment(date, urlDateFormat).format(urlDateFormat);
    }

    const [searchParams, setSearchParams] = useSearchParams();
    const handleViewRequested = ({ from, to, valid }) => {
        const params = new URLSearchParams(location.search);

        params.set('from', formatDate(from));
        params.set('to', formatDate(to));
        if(!valid)
            params.set('valid', false);
        else
            params.delete('valid');

        dispatch(clearAuditRecords());
        if(valid) {
            setSearchParams(params);
        }
    };

    // Set up the default parmameters for the audit records
    useEffect(() => {
        if(searchParams.size === 0) {
            const defaultStartDate = Moment().startOf('day').add(-6, 'days').toDate();
            const defaultEndDate = Moment().startOf('day').toDate();

            const params = new URLSearchParams(location.search);
            params.set('from', formatDate(defaultStartDate));
            params.set('to', formatDate(defaultEndDate));
            setSearchParams(params);
        }
    }, [location.search, searchParams, setSearchParams]);

    const toExclusiveDate = (value) => Moment(value).add(1, 'days').toDate();

    const onDownloadRequested = (rateCardActionAuditId, action, fileName) => {
        dispatch(downloadFile({
            rateCardActionAuditId: rateCardActionAuditId,
            action: action,
            fileName: fileName
        }));
    };

    const handleDownloadAuditReportRequested = ({ from, to }) => {
        NotificationActions.clearNotifications();
        const fileName = `Rates audit report from ${ formatDate(from) } to ${ formatDate(to) }.csv`;
        dispatch(downloadAuditFile(
            {
                from: from,
                to: toExclusiveDate(to),
                fileName: fileName
            }));
    };

    const parsedFilterFromQueryString = parseFilterFromQueryString(location, urlDateFormat);

    return (
        <div>
            <RatesAuditSearchView
                searchCriteria={ parsedFilterFromQueryString }
                onViewRequested={ handleViewRequested }
                onDownloadAuditReportRequested={ handleDownloadAuditReportRequested }
            />
            {
                auditRecords && auditRecords.rows.length > 0 ?
                    <RatesAuditTableView
                        auditRecords={ auditRecords.rows }
                        downloadRequested={ onDownloadRequested }
                    /> : React.Fragment
            }
        </div>
    );
}
